import { createContext } from "react";
import { UserCredentials } from "../types";

type AuthContext = {
  user: UserCredentials | null;
  setUser: (user: UserCredentials | null) => void;
  loading: boolean;
};

export const AuthContext = createContext<AuthContext | null>(null);
